'use client';

/**
 * Notifies users when they loose internet connection
 *
 * @packageDocumentation
 * @category Component
 */

import { type SnackbarAnchorOrigin, type SnackbarKey, useSnackbar } from 'BomdisoftComponents/notifications/snackbars/store';
import { SAVED_COPY_MARK } from 'BomdisoftComponents/pwa/register-service-worker/index';
import { connectionRestored, getLanguageFromLocale, lostConnection } from '@bomdisoft/translations';
import { useParams } from 'next/navigation';
import { useEffect, useState } from 'react';

export type OfflineProps = Record<string, never>;

export const Offline = (_props: OfflineProps) => {
  const params = useParams();
  const currentLanguage = getLanguageFromLocale(params?.lang as string) ?? 'english';
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const anchorOrigin: SnackbarAnchorOrigin = { horizontal: 'center', vertical: 'top' };

  const [offlineKey, setOfflineKey] = useState<SnackbarKey | null>(null);

  useEffect(() => {
    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  });

  const handleOnline = () => {
    if (document.querySelector(`meta[name="${SAVED_COPY_MARK}"]`) === null) enqueueSnackbar(connectionRestored[currentLanguage], { anchorOrigin, autoHideDuration: 2000, variant: 'success' });
    if (offlineKey) {
      closeSnackbar(offlineKey);
      setOfflineKey(null);
    }
  };
  const handleOffline = () => setOfflineKey(enqueueSnackbar(lostConnection[currentLanguage], { anchorOrigin, persist: true, variant: 'error' }));

  return <></>;
};
